import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'mhz',
} as IModuleProps;
